<script setup>
import Switch from "@/components/Switch.vue";

const props = defineProps({
  onAction: {
    type: Function,
    default: () => {}
  },
  onSettingsAction: {
    type: Function,
    default: () => {}
  },
  onLogAction: {
    type: Function,
    default: () => {}
  },
  published: {
    type: Boolean,
    default: false
  },
  onPublishedChange: {
    type: Function,
    default: () => {}
  }
});
</script>

<template>
  <div id="app" class="app-container">
    <div class="header">
      <div class="left-action">
        <router-link to="/blogs">
          <div class="go-back">
            <img src="@/assets/images/arrowLeft.svg" />
            <span>{{$t('go_back_button')}}</span>
          </div>
        </router-link>
      </div>
      <div class="right-actions">
        <div class="action-button-group">
          <div class="action-button-item" @click="onLogAction">
            <img src="@/assets/images/logIconNewGrey.svg" alt="Settings" />
          </div>

          <div class="action-button-item" @click="onSettingsAction">
            <img src="@/assets/images/settingsOutline.svg" alt="Settings" />
          </div>
        </div>

        <div class="published-switch">
          <span class="published-label">{{$t('published')}}</span>
          <Switch :model-value="published" :on-toggle="onPublishedChange" />
        </div>

        <div class="action-primary-button" @click="onAction">
          <span>{{$t('save_button')}}</span>
        </div>
      </div>
    </div>

    <div class="container">
      <slot />
    </div>
  </div>
</template>


<style scoped>
.app-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background-color: #FCFCFD;
  overflow-y: auto;
}

.header {
  position: fixed;
  width: 100%;
  background-color: #FFFFFF;
  border-bottom: 1px solid #EAECF0;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  z-index: 9999;
}

.container {
  padding-top: 86px;
  padding-bottom: 30px;
  margin: 0 auto;
  max-width: 960px;
}

.go-back {
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-size: 12px;
  font-family: euclid_medium, sans-serif;
}

.right-actions {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.right-actions span {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
}

.left-action a {
  color: #040C2D;
}

.left-action a:active {
  color: #040C2D;
}

.left-action a:visited {
  color: #040C2D;
}

.left-action a:hover {
  color: #040C2D;
}

.action-link {
  cursor: pointer;
  color: #1C3CD5;
}

.log-icon{
  display: flex;
  cursor: pointer;
  align-self: center;
  width: 16px;
  height: 16px;
}

.published-switch {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.published-label {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #667085;
}
</style>
